<template>
  <div v-if="displayDownloads" class="assignment-action mr-4 d-flex">
    <b-button
      :disabled="!reportFile || isHidePrice"
      class="file-btn ml-0"
      :href="reportFile"
      target="_blank"
      :download="true"
    >
      <Tooltip :text="actionTooltip('report', !reportFile)">
        <mdicon name="file-pdf-box" />
      </Tooltip>
    </b-button>
    <b-button
      v-for="(sourceFile, key) in sourceFiles"
      :key="key"
      class="file-btn"
      :href="sourceFile.fileUrl"
      :download="true"
    >
      <Tooltip :text="actionTooltip('Source', true)">
        <mdicon name="Download" />
      </Tooltip>
    </b-button>
    <b-button class="file-btn ml-3" :href="exportLink" :download="true" target="_blank">
      <Tooltip text="Export assignment to CSV">
        <mdicon name="file-delimited-outline" />
      </Tooltip>
    </b-button>
  </div>
</template>

<script lang="ts">
import type { Assignment, SourceFile } from '@/types/Models/Assignment'
import { BButton } from 'bootstrap-vue-next'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { CONSOLIDATE } from '@/const/AssignmentTypes'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import Tooltip from '@/views/Components/Elements/Tooltip.vue'

export default defineComponent({
  name: 'Downloads',
  components: { BButton, Tooltip },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const accountStore = useAccountStore()

    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const isHidePrice: ComputedRef<boolean> = computed(() => !isStaff.value && assignment.value?.company?.hidePrice)
    const sourceFiles: ComputedRef<SourceFile[]> = computed(() => assignment.value.sourceFiles || [])
    const reportFile: ComputedRef<string> = computed(() => assignment.value.optimisationReportUrl || '')
    const exportLink: ComputedRef<string> = computed(
      () => `${import.meta.env.VITE_APP_API_LOCATION}/assignments/${assignment.value.id}/export`,
    )

    const actionTooltip = (type = '', disabled = false) => (disabled ? '' : `Download ${type} file`)

    const displayDownloads: ComputedRef<boolean> = computed(() => assignment.value.type === CONSOLIDATE)

    return {
      isHidePrice,
      sourceFiles,
      reportFile,
      exportLink,
      actionTooltip,
      displayDownloads,
    }
  },
})
</script>
